import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  FileText,
  MessageSquare,
  CircleHelp as HelpCircle
} from "lucide-react";
import { Tabs } from "../../../common";
import ManageArticles from "./ManageArticles";
import ManageTickets from "./ManageTickets";
import TabSelector from "../../../employee-service/component/TabSelector";
import { Button } from "../../../common";
import { Plus } from "lucide-react";
import { useHasPermission } from "../../../../store/hooks/useRbac";
import { PERMISSIONS } from "../../../../utils/rbac/permissions";

const HelpCenterAdminMain: React.FC = () => {
  const [activeTab, setActiveTab] = useState<"articles" | "tickets">("articles");

  const tabs = [
    {
      k: "articles" as const,
      label: "Articles",
    },
    {
      k: "tickets" as const,
      label: "User Feedback",
    },
  ];

  const canManage = useHasPermission(PERMISSIONS.HELP_CENTER_ADMIN_MANAGE || "HELP_CENTER_ADMIN_VIEW");

  return (
    <div className="bg-surface-muted">
      {/* Header Area */}
      <div className="px-6 pt-6 pb-4">
        <div className="mb-4 flex flex-wrap items-center justify-between gap-4">
          <h1 className="text-2xl md:text-3xl font-bold text-slate-900">
            Help Center Management
          </h1>

          {activeTab === "articles" && canManage && (
            <Button
              appearance="primary"
              size="large"
              className="whitespace-nowrap"
              onClick={() => {
                window.dispatchEvent(new CustomEvent('open-article-modal'));
              }}
              icon={<Plus className="w-5 h-5" />}
            >
              <span className="whitespace-nowrap">Add Article</span>
            </Button>
          )}
        </div>
        <TabSelector
          tabs={tabs}
          active={activeTab}
          onChange={setActiveTab}
        />
      </div>

      {/* Content Area */}
      <div className="relative px-6 pb-6">
        <AnimatePresence mode="wait">
          <motion.div
            key={activeTab}
            initial={{ opacity: 0, x: 10 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -10 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
            className="w-full"
          >
            {activeTab === "articles" && <ManageArticles />}
            {activeTab === "tickets" && <ManageTickets />}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
};

export default HelpCenterAdminMain;
